<template>
  <section class="home-intro" aria-labelledby="home-intro-heading">
    <div class="max-w-screen-xl mx-auto px-6">
      <div class="home-intro-inner">
        <span class="home-intro-eyebrow">Over Plug2Charge</span>
        <h2 id="home-intro-heading" class="home-intro-title">
          Zonne-energie, laden en opslag &mdash; alles onder één dak
        </h2>

        <div class="home-intro-body">
          <p>
            Bij Plug2Charge vind je alles om je huis te verduurzamen, van één betrouwbaar adres.
            We leveren complete balkon- en daksets met
            <router-link to="/categorie/zonnepanelen">all-black zonnepanelen van 400 Wp en meer</router-link>,
            slimme <router-link to="/categorie/laadpalen">laadpalen van 3,7 tot 22 kW</router-link>
            voor thuis en zakelijk, en
            <router-link to="/categorie/thuisbatterijen">thuisbatterijen van 5 tot 20 kWh</router-link>
            om je eigen stroom op te slaan &mdash; met technisch advies dat klopt.
          </p>
          <p>
            Wil je een laadpaal kopen voor je elektrische auto, je energierekening verlagen met
            zonnepanelen, of overtollige zonnestroom bewaren in een thuisaccu? Onze energiespecialisten
            helpen je de juiste combinatie te kiezen voor jouw dak, meterkast en verbruik, zodat opwek,
            opslag en laden straks naadloos samenwerken.
          </p>
          <p>
            Alles wat we verkopen komt uit eigen voorraad: voor 15:00 besteld, morgen in huis. Gratis
            verzending vanaf €50, 2 jaar garantie op elk product en 30 dagen retour. Weet je niet waar je
            moet beginnen? Doe de <router-link to="/keuzehulp">keuzehulp</router-link> of
            <router-link to="/klantenservice">neem contact op</router-link> &mdash; dan denken we vrijblijvend met je mee.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
// Statische SEO-/introsectie: geeft context en keyword-dekking (zonnepanelen,
// laadpalen, thuisbatterijen, laadpaal kopen, thuisaccu) plus beschrijvende
// interne links naar de drie pijlers. Volledig server-rendered.
</script>

<style scoped>
.home-intro {
  background: #fff;
  padding: 4rem 0;
  border-top: 1px solid #efefef;
}

.home-intro-inner {
  max-width: 760px;
}

.home-intro-eyebrow {
  display: inline-block;
  background: rgba(255, 213, 0, 0.15);
  color: #7a5f00;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 0.3rem 1rem;
  border-radius: 50px;
  border: 1px solid rgba(255, 213, 0, 0.3);
  margin-bottom: 0.875rem;
}

.home-intro-title {
  font-size: clamp(1.5rem, 3.2vw, 2.125rem);
  font-weight: 900;
  color: #111;
  line-height: 1.15;
  letter-spacing: -0.02em;
  margin: 0 0 1.25rem;
  text-wrap: balance;
}

.home-intro-body p {
  font-size: 1rem;
  line-height: 1.75;
  color: #444;
  margin: 0 0 1rem;
}
.home-intro-body p:last-child { margin-bottom: 0; }

.home-intro-body :deep(a) {
  color: #111;
  font-weight: 600;
  text-decoration: none;
  box-shadow: inset 0 -2px 0 0 #FFD500;
  transition: box-shadow 0.15s, background 0.15s;
}
.home-intro-body :deep(a:hover) {
  background: #fffbeb;
  box-shadow: inset 0 -3px 0 0 #FFD500;
}
</style>
